<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
      <a-form-item><div class="login-type">账号登录</div></a-form-item>
      <a-tabs
        :activeKey="customActiveKey"
        size="large"
        :tabBarStyle="{
          textAlign: 'center',
          borderBottom: 'unset',
          color: 'grey'
        }"
        @change="handleTabClick"
      >
        <a-tab-pane key="tab1" tab="账号密码登录">
          <a-alert
            v-if="isLoginError"
            type="error"
            showIcon
            style="margin-bottom: 24px;"
            message="账户或密码错误"
          />
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="账户"
              v-decorator="[
                'account',
                {
                  rules: [
                    { required: true, message: '请输入邮箱/手机号' },
                    { validator: handleMobileOrEmail }
                  ],
                  validateTrigger: 'change'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="user"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="密码"
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入密码' }],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane key="tab2" tab="手机号登录">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="手机号"
              v-decorator="[
                'account',
                {
                  rules: [
                    {
                      required: true,
                      pattern: /^1[3456789]\d{9}$/,
                      message: '请输入正确的手机号'
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="mobile"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
          <a-row>
            <a-col class="gutter-row" :span="24">
              <a-form-item>
                <div style="display: flex;align-items: center;justify-content: space-between;">
                  <img width="200" height="40" style="margin-left: 5px;" :src="caImageSrc"/>
                  <a-button @click.stop.prevent="getCaImage">刷新</a-button>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="gutter-row" :span="24">
              <a-form-item>
                <a-input
                    size="large"
                    type="text"
                    placeholder="图片验证码"
                    v-decorator="[
                    'captchaCode',
                    {
                      rules: [{ required: true, message: '请输入图片验证码' }],
                      validateTrigger: 'blur'
                    }
                  ]"
                >
                  <a-icon
                      slot="prefix"
                      type="mail"
                      :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="验证码"
                  v-decorator="[
                    'verifyCode',
                    {
                      rules: [{ required: true, message: '请输入验证码' }],
                      validateTrigger: 'blur'
                    }
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="mail"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="
                  (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                "
              ></a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          >登录</a-button
        >
      </a-form-item>
      <a-form-item style="margin-top:24px">
        <div style="text-align: center;">
          <a href="https://xunyu-img.oss-cn-beijing.aliyuncs.com/apk/xunyu.apk">手机APP下载</a>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
// import md5 from "md5";
import Vue from "vue";
import { mapActions } from "vuex";
import { timeFix } from "@/utils/util";
import { ACCOUNT_TYPE, ACCOUNT_TYPE_INFO } from "../../store/mutaion-types.js";
// import loginApi from '@/api/login';

export default {
  data() {
    return {
      customActiveKey: "tab1",
      loginBtn: false,
      // login type: 0 email, 1 mobile, 2 captcha
      loginType: 0,
      isLoginError: false,
      form: this.$form.createForm(this),
      caImageSrc: "",
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 mobile, 2 captcha
        loginType: 0,
        smsSendBtn: false,
        verifyNo: ""
      }
    };
  },
  created() {},
  methods: {
    ...mapActions(["Login", "Logout"]),
    // handler
    handleMobileOrEmail(rule, value, callback) {
      const emailRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
        value
      );
      const mobileRegex = /^[1]([3-9])[0-9]{9}$/.test(value);
      if (value) {
        if (!emailRegex && !mobileRegex) {
          callback("请输入正确的邮箱或手机号");
        } else {
          if (emailRegex) {
            this.loginType = 0;
          } else {
            this.loginType = 1;
          }
          callback();
        }
      }
      callback();
    },
    handleTabClick(key) {
      this.customActiveKey = key;
      this.form.resetFields();
      if(key == 'tab2'){
        this.getCaImage();
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      let validateFieldsKey =
        this.customActiveKey === "tab1"
          ? ["account", "password"]
          : ["account", "verifyCode"];
      this.isLoginError = false;
      this.state.loginBtn = true;
      this.form.validateFields(
        validateFieldsKey,
        { force: true },
        (err, values) => {
          if (!err) {
            const loginParams = { ...values };
            if (this.customActiveKey == "tab1") {
              if (this.loginType == 0) {
                loginParams.loginType = "email";
              } else {
                loginParams.loginType = "mobile";
              }
            } else {
              loginParams.loginType = "mobile_captcha";
              loginParams.verifyNo = this.state.verifyNo;
            }
            this.Login(loginParams)
              .then(res => this.loginSuccess(res))
              .catch(err => this.requestFailed(err))
              .finally(() => {
                this.state.loginBtn = false;
              });
          } else {
            setTimeout(() => {
              this.state.loginBtn = false;
            }, 600);
          }
        }
      );
    },
    getCaptcha(e) {
      e.preventDefault();
      this.form.validateFields(["account","captchaCode"], { force: true }, (err, values) => {
        if (!err) {
          this.state.smsSendBtn = true;
          const interval = window.setInterval(() => {
            if (this.state.time-- <= 0) {
              this.state.time = 60;
              this.state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);

          const hide = this.$message.loading("验证码发送中..", 0);
          const param = {};
          param.account = values.account;
          param.accountType = "SMS";
          param.verifyType = "login_sure";
          param.captchaCode = values.captchaCode;
          Vue.ls.set(ACCOUNT_TYPE, ACCOUNT_TYPE_INFO.NORMAL);
          this.$http.loginBksApi
            .sendVerify(param)
            .then(res => {
              if (res) {
                setTimeout(hide, 2500);
                this.state.verifyNo = res.resultObject;
                this.$notification["success"]({
                  message: "提示",
                  description: "验证码发送成功",
                  duration: 8
                });
              } else {
                setTimeout(hide, 1);
                clearInterval(interval);
                this.state.time = 60;
                this.state.smsSendBtn = false;
              }
            })
            .catch(err => {
              setTimeout(hide, 1);
              clearInterval(interval);
              this.state.time = 60;
              this.state.smsSendBtn = false;
              this.requestFailed(err);
            });
        }
      });
    },
    async getCaImage(){
      let imgUrl = await this.$http.loginBksApi.getCaptcha();
      if(imgUrl){
        this.caImageSrc = imgUrl;
      }
    },
    loginSuccess(res) {
      if (res && res.result == 0) {
        this.$router.push({ path: "/" });
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: "欢迎",
            description: `${timeFix()}，欢迎回来`,
            duration: 2
          });
        }, 1000);
        this.isLoginError = false;
      }
    },
    requestFailed(err) {
      this.isLoginError = true;
      this.$notification["error"]({
        message: "错误",
        description:
          ((err.response || {}).data || {}).message ||
          err.message ||
          "请求出现错误，请稍后再试",
        duration: 4
      });
    }
  }
};
</script>

<style lang="less">
.main {
  background-color: #ffffff;
  padding: 10px 40px;
  border-radius: 10px;
}
.user-layout-login {
  .login-type {
    padding-top: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: grey;
  }
  // .ant-tabs-nav .ant-tabs-tab-active {
  // 	color: #000;
  // }
  .ant-tabs-ink-bar {
    height: 0px;
  }
  .ant-input {
    border-radius: 10px !important;
  }
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
    font-size: 12px;
    border-radius: 10px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    width: 100%;
    border-radius: 10px;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
